
export const FormatDate = (dateString: string) => new Date(dateString);